/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { isStrEmptyOrNull } from '../../common/UtilityFunctions';
import { useLDCContext } from '../../contexts/LoanDefaultCodesContext';
import LoanInformationStyles from '../../css/LoanInformation.module.css';
import DateInputRow from './DateInputRow';
import SelectDropdown from './Dropdown';

const actionsCol = () => {
  const { LDCInfo, LDCUIStatuses, LDCFunctions, actionsColToggled } = useLDCContext();
  const { editCutoffActionVars, handleLDCChange } = LDCFunctions;
  const { isEditable } = LDCUIStatuses;

  const { CompletionDate, CutoffActionDate, CutoffActionReportingDate } = LDCInfo.dates;

  const { CutoffActionFHLMCOptions, CutoffActionFNMAOptions } = LDCInfo.QIDOptions;

  const { fhlmcCutoffActionCode, fnmaCutoffActionCode, investorLoanTypeKeyword } = LDCInfo;

  return (
    actionsColToggled && (
      <table className={LoanInformationStyles.loanInfoTableSection}>
        <tbody>
          <tr>
            <th>Actions</th>
          </tr>

          {investorLoanTypeKeyword.startsWith('FHLMC') && (
            <SelectDropdown
              name={'fhlmcCutoffActionCode'}
              value={fhlmcCutoffActionCode}
              options={CutoffActionFHLMCOptions}
              label={'FHLMC Cutoff Action Code'}
            ></SelectDropdown>
          )}

          {investorLoanTypeKeyword.startsWith('FNMA') && (
            <SelectDropdown
              name={'fnmaCutoffActionCode'}
              value={fnmaCutoffActionCode}
              options={CutoffActionFNMAOptions}
              label={'FNMA Cutoff Action Code'}
            ></SelectDropdown>
          )}

          {((investorLoanTypeKeyword.startsWith('FHLMC') && fhlmcCutoffActionCode != '') ||
            investorLoanTypeKeyword.startsWith('FNMA')) &&
            DateInputRow(
              'Cutoff Action Date',
              CutoffActionDate,
              'dates.CutoffActionDate',
              !isEditable,
              editCutoffActionVars,
            )}

          {investorLoanTypeKeyword.startsWith('FHLMC') &&
            fhlmcCutoffActionCode != '' &&
            DateInputRow('Reporting Date', CutoffActionReportingDate, 'dates.CutoffActionReportingDate', !isEditable)}

          {investorLoanTypeKeyword.startsWith('FNMA') &&
            DateInputRow(
              'Completion Date',
              CompletionDate.activeDate,
              'dates.CompletionDate.activeDate',
              !isEditable,
              (e) => {
                handleLDCChange('edit', 'dates.CompletionDate.active', isStrEmptyOrNull(e.target.value) ? false : true);
              },
            )}
        </tbody>
      </table>
    )
  );
};

export default actionsCol;
